import { useState, useCallback } from 'react';

/**
 * Like react-use's useToggle, but for a state that is a map of `id` -> `boolean`.
 *
 * `initialState` should be a stable object
 *
 * Returns {state, toggle} (and also reset and setState if needed)
 */
export const useToggleMap = (initialState) => {
  const [state, setState] = useState(initialState);

  const toggle = useCallback(
    (id) => setState((current) => ({ ...current, [id]: !current[id] })),
    [],
  );
  const reset = useCallback(() => setState(initialState), [initialState]);

  return { state, toggle, reset, setState };
};
